import { useGamesStore } from '../../store';

export const useExcludedActiveBonusGamesList = () => {
  const excludedActiveBonusGamesList = useGamesStore(
    'excludedActiveBonusGamesList'
  );
  const { data: excludedBonusGamesList, ...rest } =
    excludedActiveBonusGamesList;

  return { excludedBonusGamesList, ...rest };
};
